import Model from "./base/model";

class TransporterDriver extends Model{
  resourceName() {
    return "transporter_drivers";
  }

  fields() {
    return {
      transporter: { jsonApi: "hasOne", type: "transporters"},
      driver: { jsonApi: "hasOne", type: "drivers"},
    };
  }
}

export default new TransporterDriver();
